import {size} from 'lodash';
import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';

import NotFound from 'components/shared/error/not_found';
import useAppContext from 'conf/AppContext';
import Types from 'conf/types';

const propTypes = {
  id: PropTypes.string.isRequired,
};
/**
 * Redirect Hgnc to the related page.
 *
 * @param {object} props - props container
 * @param {string} props.id
 * @return {JSX.Element}
 */
export default function RedirectHgnc({id}) {
  const appContext = useAppContext();
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      try {
        const rez = await appContext.api.get('data/gene', {
          searchParams: {
            symbol: id,
            view: 'min',
          },
          parseJson: true,
        });
        if (mounted) {
          if (size(rez.data) === 1) {
            appContext.redirect(Types.gene.url(rez.data[0].id), true);
          } else {
            setError(<NotFound />);
          }
        }
      } catch (err) {
        if (mounted) {
          setError(<NotFound />);
        }
      }
    };
    // noinspection JSIgnoredPromiseFromCall
    loadData();
    return () => {
      mounted = false;
    };
  }, [id]);
  
  return error;
}
RedirectHgnc.propTypes = propTypes;
